import { newToolFilterOAuthMcp } from "../oauth.ts";

export const paypalMcpResolver = newToolFilterOAuthMcp({
  iconUrl:
    "https://www.paypalobjects.com/marketing/web/icons/monogram/pp196.png",
  url: "https://mcp.paypal.com/mcp",
  label: "PayPal",
});
